import React from 'react';
import type { IconName } from '@sweetgreen/garnish';
import { Button } from '@sweetgreen/garnish';

export const LocationDetailsPill = React.memo(
  (props: LocationDetailsPillProps) => {
    const { id, title, icon, onPress } = props;

    return (
      <Button
        testID={`location.details.pill.${id}`}
        palette="secondary"
        leftIcon={icon}
        onPress={onPress}
      >
        {title}
      </Button>
    );
  },
);

type LocationDetailsPillProps = {
  readonly id: string;
  readonly title: string;
  readonly icon: IconName;
  readonly onPress: () => void;
};
